export default {
  loading: false,
  batches: {
    list: [],
    loading: false
  },
  list: {},
  detailsSelectedBatches: [],
  companyBranches: {
    list: [],
    loading: false
  },
  selectedBatch: {},
  legalQualities: {
    list: [],
    loading: false
  },
  batchClassification: {
    list: [],
    loading: false
  },
  pagination: {
    items: 0,
    pages: 0
  },
};
